import { create } from 'zustand';

// TODO: Remove this store when V2 is the only vehicle list view.
// At that point, revert ConversationSidebar back to local useState
// and remove the ConversationChip from VehicleListV2.
interface ConversationSidebarMobileState {
	close: () => void;
	isOpen: boolean;
	open: () => void;
}

export const useConversationSidebarMobile = create<ConversationSidebarMobileState>((set) => ({
	close: () => set({ isOpen: false }),
	isOpen: false,
	open: () => set({ isOpen: true }),
}));
